/* eslint-disable import/no-extraneous-dependencies */
import { useState, useContext } from 'react';

import JobListContext from '../app/context/jobListContext';
import filter from "../components/filterDeleteButton/filter";

const useReactiveSearch = () => {
  const { filtersReactive, filteredReactiveJobList, reactiveJobList, updateFilteredReactiveJobList } = useContext(
    JobListContext
  );

  const handleSearch = (event: any) => {
    if (event) {
      event.preventDefault();
      let jobList = [];

      if (
        filtersReactive.periodFilter !== '' ||
        filtersReactive.priortiyFilters.length ||
        filtersReactive.slaFilters.length ||
        filtersReactive.statusFilters.length ||
        filtersReactive.periodFilter != '' ||
        filtersReactive.buildingFilters != undefined &&
        Object.keys(filtersReactive.buildingFilters).length
      ) {
        jobList = filteredReactiveJobList;
      } else {
        jobList = reactiveJobList;
      }

      updateFilteredReactiveJobList(
        jobList.filter(job => {
          // ADD MORE FILTER CRITERIAS
          return (
            job.CallNo.toString()
              .toLowerCase()
              .indexOf(event.target.value.toLowerCase()) >= 0 ||
            job.CallDescription.toString()
              .toLowerCase()
              .indexOf(event.target.value.toLowerCase()) >= 0 ||
            job.FaultNotes.toString()
              .toLowerCase()
              .indexOf(event.target.value.toLowerCase()) >= 0 ||
            job.CustomerReference.toString()
              .toLowerCase()
              .indexOf(event.target.value.toLowerCase()) >= 0
          );
        })
      );
    }
  };

  return {
    handleSearch,
  };
};

export default useReactiveSearch;
